export enum IImportProcessTypes {
  CREATE_IMPORT_PROCESS_REQUEST = '@import-process/CREATE_IMPORT_PROCESS_REQUEST',
  CREATE_IMPORT_PROCESS_SUCCESS = '@import-process/CREATE_IMPORT_PROCESS_SUCCESS',
  CREATE_IMPORT_PROCESS_FAILURE = '@import-process/CREATE_IMPORT_PROCESS_FAILURE',

  GET_LATEST_IMPORT_PROCESS_REQUEST = '@import-process/GET_LATEST_IMPORT_PROCESS_REQUEST',
  GET_LATEST_IMPORT_PROCESS_SUCCESS = '@import-process/GET_LATEST_IMPORT_PROCESS_SUCCESS',
  GET_LATEST_IMPORT_PROCESS_FAILURE = '@import-process/GET_LATEST_IMPORT_PROCESS_FAILURE',
}

export interface ICreateImportProcessRequestAction {
  type: typeof IImportProcessTypes.CREATE_IMPORT_PROCESS_REQUEST;
  payload: {
    referenceId: string;
    type: string;
    operation: string;
    fileName: string;
    createdById: number;
    successPushUrl?: string;
  };
}

export interface ICreateImportProcessSuccessAction {
  type: typeof IImportProcessTypes.CREATE_IMPORT_PROCESS_SUCCESS;
}
export interface ICreateImportProcessFailureAction {
  type: typeof IImportProcessTypes.CREATE_IMPORT_PROCESS_FAILURE;
}

export interface IGetLatestImportProcessRequestAction {
  type: typeof IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_REQUEST;
  payload: {
    referenceId: string;
  };
}

export interface IGetLatestImportProcessSuccessAction {
  type: typeof IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_SUCCESS;
  payload: {
    importProcess: IImportProcess;
  };
}
export interface IGetLatestImportProcessFailureAction {
  type: typeof IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_FAILURE;
}

export type IImportProcessActionsType =
  | ICreateImportProcessRequestAction
  | ICreateImportProcessSuccessAction
  | ICreateImportProcessFailureAction
  | IGetLatestImportProcessRequestAction
  | IGetLatestImportProcessSuccessAction
  | IGetLatestImportProcessFailureAction;

export interface IImportProcess {
  id: string;
  referenceId: string;
  type: string;
  operation: string;
  filePath: string;
  status: string;
  log?: string | string[];
  createdById: number;
  createdAt: Date;
}

export interface IImportProcessState {
  loadingList: boolean;
  loadingCreate: boolean;
  loadingGetLatest: boolean;

  sortOrder: ISortOrder;
  sortBy: ISortBy;

  totalImportProcess: number;

  importProcess: IImportProcess | null;
  importProcesses: IImportProcess[];
}

export type ISortOrder = 'asc' | 'desc';
export type ISortBy = 'operation' | 'filePath' | 'createdById' | 'createdAt';
